<template>
    <div class="news_events">
        <h2><span>安邦</span>新闻动态</h2>
        <div class="news_list">
            <router-link :to="'/news/detail?id='+i" v-for="i in 10" :key="i">
                <div class="d-flex news_list_item">
                    <div>
                        <img src="../../../assets/images/sy_zr01.jpg" alt="">
                    </div>
                    <div class="flex-auto sec_box font16">
                        <p class="e_time font14">2019年9月12日</p>
                        <h5>安邦制药斩获第二十届“中国专利优秀奖”</h5>
                        <p class="intro">{{t | limitWord(150)}}</p>
                    </div>
                </div>
            </router-link>
        </div>
        <div class="pagenation">
            <an-pagenation
                align="center">
            </an-pagenation>   
        </div>
    </div>
</template>

<script>
export default {
    name:'Events',
    data(){
        return {
            t:'“中国专利奖”始于1989年，是我国唯一的专门对授予专利权的发明创造给予奖励的政府部门奖，得到联合国世界知识产权组织（WIPO）的认可，在国际上有一定的影响，该奖项也是中国向世界展示原创能力的重要平台。中国专利奖参评项目由各地知识产权局、国务院有关部门和单位知识产权工作管理机构、全国性行业协会'
        }
    },
    methods:{
        
    }
}
</script>

<style lang="stylus">
.news_events
    .sec_box
        padding-left 20px
    h2
        font-weight normal
        margin-bottom 12px
        color #ED822A
        font-size 36px
        span
            color #1278C6
    .news_list
        .news_list_item
            border-bottom 1px solid #89BAE0
        img 
            width 240px
            height 166px  
        .e_time
            color #ED822A
        h5
            color #1278C6
            font-size 16px
            margin 12px 0
        .intro
            color #222222
            line-height 24px   
    .pagenation
        margin 58px 0    
</style>